<template>
  <li class="cell">
    <div class="cell-container">
      <div class="cell-content">
        <div v-if="event.featured_images.length" class="cell-img" :style="'background-image:url(' + encodeURI(event.featured_images[0].image.url) + ')'"></div>

        <div class="cell-fields">
          <p class="cell-date">{{event.artist_name}} <template v-if="event.time">&bull; {{event.time}}</template></p>

          <p class="cell-title" v-html="event.program_title"></p>

          <p v-if="event.address" class="cell-address">{{event.address}} {{event.address_2}}</p>

          <p class="event-stats">{{event.category}} &bull; {{event.event_type === 'Other' ? event.event_type_other : event.event_type}}</p>

          <p v-if="event.description.length > 40" class="user-selectable">
            <span v-if="!aboutShowing">{{ aboutShort }}...</span>
            <span v-if="aboutShowing">{{ event.description }}</span>
            <button v-if="!aboutShowing" @click.prevent="aboutShowing = true">more</button>
          </p>
          <p v-else class="user-selectable">{{ event.description }}</p>

          <p class="location-details"><template v-if="event.location_type">{{event.location_type}}</template><template v-if="event.location_experience.length"><span v-for="exp in event.location_experience" :key="exp"> &bull; {{exp}}</span></template></p>

          <a v-if="event.additional_links && event.additional_links.indexOf('http') > -1" :href="event.additional_links" class="btn" target="_blank">Additional Resources</a>
          <a v-if="event.location_rsvp && event.location_rsvp.indexOf('http') > -1" :href="event.location_rsvp" class="btn" target="_blank">RSVP</a>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ['event'],
  data() {
    return {
      aboutShowing: false,
    }
  },
  computed: {
    aboutShort() {
      if (!this.event.description) return '';
      let txt = this.event.description.split("").splice(0, 70);
      if (txt[txt.length - 1] === " ") txt.pop();
      return txt.join("");
    },
  }
}
</script>

<style scoped lang="less">
@import '../css/variables';

.cell {
  position: relative;
  overflow: hidden;
  padding-left: 20px;
}

.cell-content {
  position: relative;
  display: flex;
  padding: 20px 20px 20px 0;
  color: #000;
  text-decoration: none;
  background-color: #fff;
  border-bottom: 1px solid #EBEBEB;
  z-index: 2;
  p,
  a {
    margin-bottom: 7px;
    font-size: 15px;
    line-height: 18px;
    &.cell-date {
      color: @themeColor1;
    }
    &.event-stats {
      font-weight: bold;
    }
    &.location-details {
      margin-top: 10px;
      color: @themeColor3;
    }
    &:last-child {
      margin-bottom: 0;
    }
    button {
      font-weight: bold;
      color: @themeColor2;
    }
  }

  .cell-img {
    min-width: 61px;
    height: 61px;
    background-size: cover;
    background-position: center;
    background-color: #1e1e1e;
    border-radius: 61px;
    margin-right: 13px;
  }

  .cell-fields {
    max-width: calc(~'100% - 74px');
    .cell-title {
      display: block;
      overflow: hidden;
      font-size: 25px;
      font-weight: bold;
      line-height: 33px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CellEvent.vue